/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState } from 'react';
import {
  MDBBadge, MDBBtn, MDBTable, MDBTableHead, MDBTableBody, MDBCheckbox, MDBPagination, MDBPaginationItem, MDBPaginationLink
} from 'mdb-react-ui-kit';
import Attribution from '../utils/Interface/Attribution';
import "../style/css/tablecomplexe.css"


interface Props {
  attributions: Attribution[];
  textaction: string;
  onClick: (attribution_id: number) => void;
  onCheckClick: (attribution_id: number, glpi_user_id: number) => void;
}

const TableComplexe: React.FC<Props> = ({ attributions, textaction,  onCheckClick, onClick }) => {

  const [currentPage, setCurrentPage] = useState(1);

  const attributionsPerPage = 10;
  const totalPages = Math.ceil(attributions.length / attributionsPerPage);
  const indexOfLastAttribution = currentPage * attributionsPerPage;
  const indexOfFirstAttribution = indexOfLastAttribution - attributionsPerPage;
  const currentAttributions = attributions.slice(indexOfFirstAttribution, indexOfLastAttribution);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleCheckClick = (attribution_id: number, glpi_user_id: number) => {
    onCheckClick(attribution_id, glpi_user_id);
    window.location.href = `/inventaire/utilisateurs/${glpi_user_id}`;
  };

  return (
    <div className='tablecomplexe'>

      <MDBTable align='middle' className='tablecomplexe__table'>

        <MDBTableHead>

          <tr className='tablecomplexe__table__categories' >
           
            <th scope='col' className='fw-bold mb-1'>Utilisateur</th>
            <th scope='col' id="tablecomplexeremove" className='fw-bold mb-1'>Entité</th>
            <th scope='col' id="tablecomplexeremove" className='fw-bold mb-1'>Etat</th>
            <th scope='col' className='fw-bold mb-1'>Numéro de série</th>
            <th scope='col' id="tablecomplexeremove" className='fw-bold mb-1'>Modèle</th>
            <th scope='col' className='fw-bold mb-1'>Actions</th>

          </tr>

        </MDBTableHead>

        <MDBTableBody>

          {currentAttributions.map((attribution,index) => (

            <tr key={index} className='tablecomplexe__table__items' >

              <td onClick={() => handleCheckClick(attribution.attribution_id, attribution.glpi_user_id)}>

                <div className='d-flex align-items-center'>

                  <div className='ms-3'>

                    <p className='fw-bold mb-1'>{attribution.user_name}</p>

                    <p className='text-muted mb-0'>{attribution.user_firstname}</p>

                    <p id="tablecomplexeremove2" className='text-muted mb-0'>{attribution.user_email}</p>

                  </div>

                </div>

              </td>

              <td id="tablecomplexeremove" onClick={() => handleCheckClick(attribution.attribution_id, attribution.glpi_user_id)}>

                <p className='fw-normal mb-1'>{attribution.entity_name}</p>

              </td>

              <td id="tablecomplexeremove" onClick={() => handleCheckClick(attribution.attribution_id, attribution.glpi_user_id)}>

                <MDBBadge color={attribution.state === 'document créé' ? 'success' : 'danger'} pill>

                  {attribution.state === 'document créé' ? 'document créé' : 'En attente'}

                </MDBBadge>

              </td>

              <td onClick={() => handleCheckClick(attribution.attribution_id, attribution.glpi_user_id)}>

                {attribution.monitor_serial} {attribution.phone_serial} {attribution.computer_serial}

              </td>

              <td id="tablecomplexeremove" onClick={() => handleCheckClick(attribution.attribution_id, attribution.glpi_user_id)}>

                {attribution.monitor_model} {attribution.phone_model} {attribution.computer_manufacturer}

              </td>

              <td>

                <MDBBtn color='link' rounded size='sm'>

                  <div
                  onClick={() => onClick(attribution.attribution_id)}   
                  className="btn btn-link btn-sm btn-rounded"
                  id="btntable"
                  >

                    {textaction}

                  </div>

                </MDBBtn>

              </td>

            </tr>

          ))}

        </MDBTableBody>

      </MDBTable>

      {totalPages > 1 && (

      <nav aria-label='Page navigation'>

        <MDBPagination circle className='mb-0'>

          <MDBPaginationItem disabled={currentPage === 1}>

            <MDBPaginationLink onClick={() => handlePageChange(currentPage - 1)} tabIndex={-1} aria-disabled={currentPage === 1}>

              <p className='page'>Page précédente</p>

            </MDBPaginationLink>

          </MDBPaginationItem>

          <MDBPaginationItem disabled={currentPage === 1}>

            <MDBPaginationLink onClick={() => handlePageChange(1)} tabIndex={-1} aria-disabled={currentPage === 1}>

              <p className='page' id='number'>1</p>

            </MDBPaginationLink>

          </MDBPaginationItem>

          {currentPage !== 1 && (
            <MDBPaginationItem>

              <MDBPaginationLink>

                <p className='page' id='number'>{currentPage}</p>

              </MDBPaginationLink>

            </MDBPaginationItem>
          )}

          <MDBPaginationItem disabled={currentPage === totalPages}>

            <MDBPaginationLink onClick={() => handlePageChange(totalPages)}>

              <p className='page' id='number'>{totalPages}</p>

            </MDBPaginationLink>

          </MDBPaginationItem>

          <MDBPaginationItem disabled={currentPage === totalPages}>

            <MDBPaginationLink onClick={() => handlePageChange(currentPage + 1)} aria-disabled={currentPage === totalPages}>

              <p className='page'>Page suivante</p>

            </MDBPaginationLink>

          </MDBPaginationItem>

        </MDBPagination>

      </nav>
      )}

    </div>
  );
}

export default TableComplexe;